<template>
  <div>
    <b-row class="my-2">
      <b-col cols="6">
        <feather-icon class="mr-75" icon="CheckIcon" />
        <span class="font-weight-bold"> شناسه </span>
      </b-col>
      <b-col cols="6"> {{ userData.id || "-" }} </b-col>
    </b-row>
    <b-row class="my-2">
      <b-col cols="6">
        <feather-icon class="mr-75" icon="UserCheckIcon" />
        <span class="font-weight-bold"> نام </span>
      </b-col>
      <b-col cols="6"> {{ userData.first_name || "-" }} </b-col>
    </b-row>
    <b-row class="my-2">
      <b-col cols="6">
        <feather-icon class="mr-75" icon="UserCheckIcon" />
        <span class="font-weight-bold"> نام خانوادگی </span>
      </b-col>
      <b-col cols="6"> {{ userData.last_name || "-" }} </b-col>
    </b-row>
    <b-row class="my-2">
      <b-col cols="6">
        <feather-icon class="mr-75" icon="PhoneIcon" />
        <span class="font-weight-bold"> شماره تماس </span>
      </b-col>
      <b-col cols="6"> 0{{ userData.mobile || "-" }} </b-col>
    </b-row>
    <b-row class="my-2">
      <b-col cols="6">
        <feather-icon class="mr-75" icon="MailIcon" />
        <span class="font-weight-bold"> ایمیل </span>
      </b-col>
      <b-col cols="6"> {{ userData.email || "-" }} </b-col>
    </b-row>
    <b-row class="my-2">
      <b-col cols="6">
        <feather-icon class="mr-75" icon="UserIcon" />
        <span class="font-weight-bold"> جنسیت </span>
      </b-col>
      <b-col cols="6">
        {{ userData.gender == 0 ? "مرد" : "زن" }}
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol } from "bootstrap-vue";
export default {
  components: {
    BRow,
    BCol,
  },

  props: {
    userData: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style></style>
